<template>
  <div class="table-responsive">
    <table class="table table-striped order-summary">
      <thead class="active">
        <tr>
          <th class="rma-number">Number</th>
          <th class="rma-order-number" colspan="2">Order Number</th>
          <th class="rma-date">Date</th>
          <th class="rma-status" colspan="2">Authorization status</th>
          <th class="rma-actions" />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="request in reimbursementRequests"
          :key="request.number"
          :class="`rma-${request.number}`"
        >
          <td class="rma-number">
            <a :href="request.url">{{ request.number }}</a>
          </td>
          <td class="rma-order-number" colspan="2">
            <a :href="request.original_order_url">{{ request.original_order }}</a>
          </td>
          <td class="rma-date">
            {{ request.requested_at }}
          </td>
          <td class="rma-status" colspan="2">
            {{ request.state }}
          </td>
          <td class="rma-actions">
            <template v-if="request.can_cancel">
              <form class="cancel-button" :action="request.cancel_path" method="POST">
                <input type="hidden" name="authenticity_token" :value="csrfToken" />
                <button type="submit" class="text-uppercase btn btn-danger">
                  Cancel
                </button>
              </form>
            </template>
            <template v-else-if="request.additional_evidence_required">
              <div class="need-more-information-well">
                <i class="glyphicon glyphicon-exclamation-sign" />
                <a
                  :href="request.url"
                  class="need-more-information"
                >
                  We need more information >
                </a>
              </div>
            </template>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'

  export default {
    props: {
      reimbursementRequests: {
        type: Array,
        required: true,
      },
    },
    computed: {
      csrfToken() {
        return Cookies.get('CSRF-TOKEN')
      },
    },
  };
</script>
